import React, { useState, useEffect } from "react";
import { observer } from "mobx-react";
import { Fade, Typography } from "@material-ui/core";

import { useStore } from "../../store";
import { Icon } from "../../components";
import { TranslationJSX, TranslationStr } from "../../utils/Translation";
import { convertStringToHashTagHtml, convertCount } from "../../utils/convert";
import { languageAr } from "../../utils/Translation";
import firebaseEvent from "../../utils/firebaseEvent";
import {
  InfoContainer,
  MoreButton,
  InfoSummaryContainer,
  InfoSummary,
  InfoSummaryDividePoint,
} from "./style";

interface Props {
  title: string;
  description: string;
  ratio: string;
  duration: string;
  projectId: string;
  downloadCounts: number;
}

const DetailItemInfo = ({
  title,
  description,
  ratio,
  duration,
  projectId,
  downloadCounts: count,
}: Props) => {
  const {
    appStore: {
      appState: { languageCode },
    },
    detailStore: {
      onUpdateInfoState,
      infoState: { isMoreInfo },
      installState: { isInstall },
    },
  } = useStore();
  const { isAr, dir } = languageAr(languageCode);

  const [downloadCounts, setDownloadCounts] = useState(count);
  useEffect(() => {
    if (isInstall) {
      setDownloadCounts((count) => count + 1);
    }
  }, [isInstall]);

  const descRemoveSpace = description.replace("\n", " ");
  const isLess = descRemoveSpace.length > 200;
  const shortDesc = isLess
    ? `${descRemoveSpace.substr(0, 200)}... `
    : descRemoveSpace;

  //Firebase Event
  const jsonParams = {
    P1: projectId,
  };

  const convertShortDesc = convertStringToHashTagHtml(shortDesc, jsonParams);

  const MoreDescButton = () => {
    if (!isLess) return null;
    const onClick = (e: any) => {
      e.stopPropagation();
      //Firebase Event
      firebaseEvent("detail_more", jsonParams);
      onUpdateInfoState({ isMoreInfo: true, title, description });
    };

    return (
      <MoreButton onClick={onClick}>
        <TranslationJSX locoKey="feed_more" />
      </MoreButton>
    );
  };

  const textAlign = isAr ? "right" : "left";

  const downloadCountss = TranslationStr({
    locoKey: "project_info_downloads",
    languageCode,
  }).replace("%d", convertCount(downloadCounts));

  const ratioIcon = () => {
    if (ratio === "16:9") {
      return "ratio_16_9";
    } else if (ratio === "9:16") {
      return "ratio_9_16";
    } else {
      return "ratio_1_1";
    }
  };

  return (
    <Fade in={!isMoreInfo}>
      <InfoContainer style={{ textAlign }}>
        <Typography className="info-title-ellipsis" variant="h5" dir={dir}>
          {title}
        </Typography>
        <Typography
          dir={dir}
          variant="body2"
          component="span"
          className="info-description"
        >
          {convertShortDesc}
          <MoreDescButton />
        </Typography>
        <InfoSummaryContainer dir={dir}>
          <InfoSummary>
            <Icon name="time" />
            <Typography variant="caption">{duration}</Typography>
          </InfoSummary>
          <InfoSummary>
            <Icon name={ratioIcon()} />
            <Typography variant="caption">{ratio}</Typography>
          </InfoSummary>
          <InfoSummary className="count">
            <InfoSummaryDividePoint />
            <Typography variant="caption">{downloadCountss}</Typography>
          </InfoSummary>
        </InfoSummaryContainer>
      </InfoContainer>
    </Fade>
  );
};

export default observer(DetailItemInfo);
